module.exports = __webpack_public_path__ + "static/media/gha_platinum_blank.59298b97.png";